// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__dQpbk","inner":"home_inner__3cxp-","button":"home_button__MgF0G","play":"home_play__3krgK"};